import React, { useMemo, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import Header from './Components/Header.js';
import Footer from "./Components/Footer.js";

const Home = () => {
    const slideImages = ['assets/images/slide/slide-2.jpg'];
    const [activeFilter, setActiveFilter] = useState('*');
    const [activeSlide, setActiveSlide] = useState(0);

    const portfolioItems = useMemo(() => ([
        { id: 1, category: 'civil', img: 'assets/images/civil/1.jpeg', title: 'civil 1', label: 'civil' },
        { id: 2, category: 'architecture', img: 'assets/images/architecture/1.jpeg', title: 'architecture 1', label: 'architecture' },
        { id: 3, category: 'civil', img: 'assets/images/civil/2.jpeg', title: 'civil 2', label: 'civil' },
        { id: 4, category: 'mep', img: 'assets/images/mep/1.jpg', title: 'mep 2', label: 'mep' },
        { id: 5, category: 'architecture', img: 'assets/images/architecture/2.jpg', title: 'architecture 2', label: 'architecture' },
        { id: 6, category: 'civil', img: 'assets/images/civil/3.jpg', title: 'civil 3', label: 'civil' },
        { id: 7, category: 'mep', img: 'assets/images/mep/2.jpg', title: 'mep 1', label: 'mep' },
        { id: 8, category: 'mep', img: 'assets/images/mep/3.jpg', title: 'mep 3', label: 'mep' },
    ]), []);

    return(
        <div>
        <Header/>
        <section id="hero">
            <div id="heroCarousel" data-bs-interval="5000" class="carousel slide carousel-fade" data-bs-ride="carousel">
                <div class="carousel-inner" role="listbox">
                    <div class="carousel-item active" style={{ backgroundImage: `url(${slideImages[0]})`}}>
                        <div class="carousel-container">
                            <div class="carousel-content animate__animated animate__fadeInUp">
                                <h2>Welcome to <span>KPA Structure</span></h2>
                                <p>We specialize in assembling and leading expert civil and structural engineering teams to take your project from concept to construction. With a commitment to safety, efficiency, and precision, we deliver reliable solutions that bring lasting value to every build.</p>
                                <div class="text-center">
                                    <a href="/" class="btn-get-started">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item" style={{ backgroundImage: `url(${slideImages[0]})`}}>
                        <div class="carousel-container">
                            <div class="carousel-content animate__animated animate__fadeInUp">
                                <h2>Welcome to <span>KPA Structure</span></h2>
                                <p>We specialize in assembling and leading expert civil and structural engineering teams to take your project from concept to construction. With a commitment to safety, efficiency, and precision, we deliver reliable solutions that bring lasting value to every build.</p>
                                <div class="text-center">
                                    <a href="/" class="btn-get-started">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item" style={{ backgroundImage: `url(${slideImages[0]})`}}>
                        <div class="carousel-container">
                            <div class="carousel-content animate__animated animate__fadeInUp">
                                <h2>Welcome to <span>KPA Structure</span></h2>
                                <p>We specialize in assembling and leading expert civil and structural engineering teams to take your project from concept to construction. With a commitment to safety, efficiency, and precision, we deliver reliable solutions that bring lasting value to every build.</p>
                                <div class="text-center">
                                    <a href="/" class="btn-get-started">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <a class="carousel-control-prev" href="#heroCarousel" role="button" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true"></span>
                </a>
                <a class="carousel-control-next" href="#heroCarousel" role="button" data-bs-slide="next">
                    <span class="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true"></span>
                </a> */}
                {/* Indicators removed to avoid Bootstrap accessing null elements */}
            </div>
        </section>
        <main id="main">
            <section id="about-us" class="about-us">
                <div class="container" data-aos="fade-up">
                    <div class="row content">
                        <div class="col-lg-6" data-aos="fade-right">
                            <h2>Trusted Civil & Structural Engineering Solutions</h2>
                            <h3>Delivering reliable civil and structural engineering solutions with safety, efficiency, and precision.</h3>
                        </div>
                        <div class="col-lg-6 pt-4 pt-lg-0" data-aos="fade-left">
                            <p>
                            We deliver trusted civil and structural engineering solutions designed to move your project forward with confidence. From planning to execution, our team ensures every step is handled with safety, efficiency, and precision.
                            </p>
                            <ul>
                                <li><i class="ri-check-double-line"></i> Comprehensive civil and structural engineering services</li>
                                <li><i class="ri-check-double-line"></i> Safe, efficient, and code-compliant project delivery</li>
                                <li><i class="ri-check-double-line"></i> Experienced teams dedicated to quality and innovation</li>
                            </ul>
                            <p class="fst-italic">Our mission is simple: to build strong foundations for communities and lasting value for our clients.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="services" class="services section-bg">
                <div class="container" data-aos="fade-up">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                            <div class="icon-box iconbox-blue">
                                <div class="icon">
                                    <img src="assets/images/logo/1.png" alt="Structural Design" style={{ width: "100px", height: "100px", position: "absolute", top: 0, left: 0 }}></img>
                                </div>
                                <h4>Structural Design & Analysis</h4>
                                <p>Custom design of safe, efficient, and resilient structures for residential, commercial, and industrial projects.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="200">
                            <div class="icon-box iconbox-orange ">
                                <div class="icon">
                                    <img src="assets/images/logo/2.jpg" alt="Civil Engineering" style={{ width: "100px", height: "100px", position: "absolute", top: 0, left: 0 }}></img>
                                </div>
                                <h4>Civil Engineering & Site Development</h4>
                                <p>Complete planning and execution of roads, utilities, grading, and drainage systems.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0" data-aos="zoom-in" data-aos-delay="300">
                            <div class="icon-box iconbox-pink">
                                <div class="icon">
                                    <img src="assets/images/logo/3.png" alt="Project Management" style={{ width: "100px", height: "100px", position: "absolute", top: 0, left: 0 }}></img>
                                </div>
                                <h4>Project Management & Consultancy</h4>
                                <p>Professional oversight from concept to completion, ensuring quality, budget control, and timely delivery.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="100">
                            <div class="icon-box iconbox-yellow">
                                <div class="icon">
                                    <img src="assets/images/logo/4.jpg" alt="Construction Supervision" style={{ width: "100px", height: "100px", position: "absolute", top: 0, left: 0 }}></img>
                                </div>
                                <h4>Construction Supervision</h4>
                                <p>On-site monitoring, quality control, and safety compliance throughout the building process.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="200">
                            <div class="icon-box iconbox-red">
                                <div class="icon">
                                    <img src="assets/images/logo/5.jpg" alt="Infrastructure Engineering" style={{ width: "100px", height: "100px", position: "absolute", top: 0, left: 0 }}></img>
                                </div>
                                <h4>Bridge & Infrastructure Engineering</h4>
                                <p>Design and evaluation of bridges, highways, and large-scale infrastructure projects.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="100">
                            <div class="icon-box iconbox-yellow">
                                <div class="icon">
                                    <img src="assets/images/logo/7.jpg" alt="Building Renovation" style={{ width: "100px", height: "100px", position: "absolute", top: 0, left: 0 }}></img>
                                </div>
                                <h4>Building Renovation & Retrofit</h4>
                                <p>Structural upgrades and retrofitting to extend the lifespan and safety of existing buildings.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="portfolio" class="portfolio">
                <div class="container portfolio-carousel">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        navigation={{
                            nextEl: ".custom-next",
                            prevEl: ".custom-prev"
                        }}
                        autoplay={{ delay: 2500 }}
                        slidesPerView={3}
                        spaceBetween={20}
                        loop={true}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            640: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 },
                        }}
                    >
                        {portfolioItems.map((item) => (
                            <SwiperSlide key={item.id}>
                                <div className="portfolio-card">
                                    <img src={item.img} alt={item.title} className="portfolio-img" />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="custom-prev"><FaChevronLeft size={20} /></div>
                    <div className="custom-next"><FaChevronRight size={20} /></div>
                </div>
            </section>
        </main>
        <Footer/>
        </div>
    )  
};

export default Home;